<div class="crm-pagina">
  <header class="crm-topo">
    <div class="titulo">
      <h2><i class="fe-users"></i>CRM de clientes</h2>
      <p>Cada cliente muda de segmento sozinho, a cada pedido e toda madrugada. Comece pelas colunas da esquerda.</p>
    </div>
    <div class="topo-acoes">
      <nav class="alternador" aria-label="Visualização">
        <a class="ativo" aria-current="page"><i class="fe-grid"></i>Quadro</a>
        <a (click)="trabalheSegmento('ESFRIANDO')" href="javascript:void(0)"><i class="fe-list"></i>Fila</a>
      </nav>
      <button type="button" class="btn-regras" (click)="regrasAbertas = true"><i class="fe-sliders"></i>Regras</button>
    </div>
  </header>

  <app-faixa-segmentos-crm [resumo]="resumoCrm" [selecionado]="segmentoEmDestaque"
                           (selecione)="destaqueColuna($event)"></app-faixa-segmentos-crm>

  <div class="barra-ferramentas">
    <div class="busca">
      <i class="fe-search"></i>
      <input type="text" placeholder="Buscar por nome ou telefone" [(ngModel)]="termoBusca" name="termoBusca"
             (keyup.enter)="onBuscaChange(termoBusca)">
      <button type="button" *ngIf="termoBusca" class="limpar-busca" (click)="onBuscaChange('')" aria-label="Limpar busca"><i class="fe-x"></i></button>
    </div>
    <button type="button" class="btn-ferramenta" (click)="exibaFiltroAvancado()"><i class="fe-filter"></i><span>Avançado</span></button>
    <kendo-combobox name="filtro" [(ngModel)]="filtro" [data]="filtros"
                    [clearButton]="Object.keys(filtro.dados).length > 0"
                    class="combo-filtro" [placeholder]="'Todos os contatos'" [textField]="'nome'"
                    (valueChange)="onBuscaChange(termoBusca)">
    </kendo-combobox>
    <button type="button" class="btn-ferramenta icone" [disabled]="!filtro?.salvar" (click)="abraModalSalvarFiltro()" title="Salvar filtro">
      <i class="fe-save"></i>
    </button>
    <button type="button" class="btn-ferramenta" (click)="exporte()" title="Exportar os clientes do filtro atual em planilha">
      <i class="fe-download"></i><span>Exportar</span>
    </button>
  </div>

  <div class="filtros-aplicados" *ngIf="Object.keys(filtro.dados).length > 0">
    <span class="rotulo"><i class="fe-filter"></i>Filtros</span>
    <button type="button" class="filtro-tag" *ngFor="let item of filtro.dados | keyvalue" (click)="removerFiltro(item.key)">
      {{ getDescricaoFiltro(item.value) }}<i class="fe-x"></i>
    </button>
    <button type="button" class="limpar-todos" (click)="limpeFiltros()">Limpar todos</button>
  </div>

  <div [hidden]="!filtro || !filtro.exibir">
    <filtro-avancado #filtroComponent
      [exibir]="filtro?.exibir"
      (onVoltar)="fecharFiltroAvancado()"
      (onFechar)="fecharFiltroAvancado()"
      (onFiltrar)="onFiltrarAvancado($event)">
    </filtro-avancado>
  </div>

  <kendo-dialog *ngIf="modalSalvarFiltro" (close)="fecheModalFiltro()" [width]="320">
    <kendo-dialog-titlebar>Salvar filtro</kendo-dialog-titlebar>
    <div class="p-3">
      <div class="form-group">
        <label>Nome do filtro</label>
        <input type="text" class="form-control" [(ngModel)]="filtro.nome" name="nomeFiltro">
      </div>
      <div class="text-danger" *ngIf="erroSalvarFiltro">{{ erroSalvarFiltro }}</div>
    </div>
    <kendo-dialog-actions>
      <button class="btn btn-secondary" (click)="fecheModalFiltro()">Cancelar</button>
      <button class="btn btn-primary" (click)="salveFiltro()">Salvar</button>
    </kendo-dialog-actions>
  </kendo-dialog>

  <section class="quadro" [class.carregando]="carregando">
    <div class="coluna" *ngFor="let coluna of colunas" [id]="'coluna-crm-' + coluna.codigo"
         [class.destaque]="segmentoEmDestaque === coluna.codigo"
         [style.--cor]="coluna.cor" [style.--fundo]="coluna.fundo">
      <div class="coluna-topo">
        <div class="coluna-titulo">
          <span class="coluna-icone"><i [class]="coluna.icone"></i></span>
          <div class="coluna-nome">
            <h3>{{ coluna.nome }}</h3>
            <span class="contagem">
              <strong>{{ numero(totalPorStatus[coluna.codigo]) }}</strong>
              <ng-container *ngIf="getContatosPorStatus(coluna.codigo).length < (totalPorStatus[coluna.codigo] || 0)">
                · vendo {{ getContatosPorStatus(coluna.codigo).length }}
              </ng-container>
            </span>
          </div>
        </div>
        <p class="coluna-acao">{{ coluna.acao }}</p>
        <div class="coluna-botoes">
          <button type="button" class="coluna-trabalhar" (click)="trabalheSegmento(coluna.codigo)"
                  [disabled]="!totalPorStatus[coluna.codigo]">
            Trabalhar <i class="fe-arrow-right"></i>
          </button>
          <button type="button" class="coluna-icone-acao" title="Criar campanha para este segmento"
                  (click)="crieCampanha(coluna.codigo)" [disabled]="!totalPorStatus[coluna.codigo]"><i class="fe-send"></i></button>
          <button type="button" class="coluna-icone-acao" title="Exportar este segmento em planilha"
                  (click)="exporte(coluna.codigo)" [disabled]="!totalPorStatus[coluna.codigo]"><i class="fe-download"></i></button>
        </div>
      </div>

      <div class="coluna-lista" #listaColuna
           infiniteScroll
           [infiniteScrollDistance]="2"
           [infiniteScrollThrottle]="50"
           [scrollWindow]="false"
           [infiniteScrollContainer]="listaColuna"
           (scrolled)="onScrollColuna(coluna.codigo)">
        <app-cartao-contato-crm *ngFor="let contato of getContatosPorStatus(coluna.codigo)"
                                [contato]="contato" (ver)="verContato($event)" (mia)="abraMia($event)"></app-cartao-contato-crm>

        <div class="coluna-vazia" *ngIf="!carregando && getContatosPorStatus(coluna.codigo).length === 0">
          <i [class]="coluna.icone"></i>
          <p>Ninguém aqui agora.</p>
          <span>{{ coluna.quem }}</span>
        </div>

        <div class="coluna-esqueleto" *ngIf="carregando && getContatosPorStatus(coluna.codigo).length === 0">
          <span></span><span></span><span></span>
        </div>

        <div class="carregando-mais" *ngIf="carregandoPorStatus[coluna.codigo]">
          <i class="fe-loader gira"></i> Carregando mais
        </div>
      </div>
    </div>
  </section>
</div>

<app-regras-crm [aberto]="regrasAbertas" [regras]="regras" [editadasEm]="regrasEditadasEm"
                [defaultCalculadoEm]="defaultCalculadoEm"
                (fechar)="regrasAbertas = false" (salvou)="salvouRegras($event)"
                (recalculou)="regrasAbertas = false"></app-regras-crm>

<app-mensagem-mia-crm [aberto]="miaAberta" [contato]="contatoMia" (fechar)="miaAberta = false"></app-mensagem-mia-crm>
